import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { Common } from './types'
import { RootState } from '../../types'

export const state: Common = {
  snackbar: null
}

const namespaced = true

export const snackbar: Module<Common, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
